'use client'
import { useAssistantContext } from './AssistantProvider'
import AssistantMessage from './AssistantMessage'
import type { AssistantAction } from './types'
import { useCallback } from 'react'

export default function AssistantPanel() {
  const assistant = useAssistantContext()
  const onActionClick = useCallback(
    (a: AssistantAction) => {
      if (a.type === 'generate_resume') {
        assistant.sendMessage('Generate resume')
      } else if (a.type === 'optimize_resume') {
        assistant.sendMessage('Optimize resume')
      } else if (a.type === 'analyze_ats') {
        assistant.sendMessage('Analyze ATS')
      }
    },
    [assistant]
  )

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = e.currentTarget
    const input = form.elements.namedItem('message') as HTMLInputElement
    const text = input.value.trim()
    if (!text) return
    input.value = ''
    await assistant.sendMessage(text)
  }

  return (
    <div
      style={{
        position: 'fixed',
        right: 16,
        bottom: assistant.open ? 16 + 72 : -1000,
        width: 360,
        maxWidth: '90vw',
        height: '80vh',
        maxHeight: '80vh',
        background: '#0b0b0f',
        color: '#ffffff',
        borderRadius: 16,
        boxShadow: '0 12px 30px rgba(0,0,0,0.35)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'bottom 0.25s ease'
      }}
    >
      <div style={{ padding: '10px 12px', borderBottom: '1px solid #1f2937', fontWeight: 600 }}>Assistant</div>
      <div ref={assistant.listRef} style={{ flex: 1, overflowY: 'auto', padding: 12, background: '#0f172a' }}>
        {assistant.messages.map(m => (
          <AssistantMessage key={m.id} msg={m} onActionClick={onActionClick} />
        ))}
        {assistant.error && <div style={{ padding: 8, color: '#f97316', fontSize: 13 }}>{assistant.error}</div>}
      </div>
      <form onSubmit={onSubmit} style={{ padding: 12, display: 'flex', gap: 8, borderTop: '1px solid #1f2937' }}>
        <input
          type="text"
          name="message"
          placeholder="Type a message..."
          disabled={assistant.sending}
          style={{
            flex: 1,
            borderRadius: 10,
            border: '1px solid #374151',
            background: '#111827',
            color: '#ffffff',
            padding: '10px 12px',
            fontSize: 14,
            outline: 'none'
          }}
        />
        <button
          type="submit"
          disabled={assistant.sending}
          style={{
            borderRadius: 10,
            border: 'none',
            background: assistant.sending ? '#6b7280' : '#0ea5e9',
            color: '#ffffff',
            padding: '10px 14px',
            fontSize: 14,
            cursor: assistant.sending ? 'not-allowed' : 'pointer'
          }}
        >
          Send
        </button>
      </form>
    </div>
  )
}
